import CrossIcon from "@Icons/CrossIcon";
import LazyImage from "@Components/Image";
import { useState } from "react";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./WeChatQRBannerDesktop.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import { BASE_OSS_URL } from "constants/configConstants";
import { posthogEventEmitter } from "@Utils/posthog";

const QR_IMAGE_SRC_COLLAPSED = `${BASE_OSS_URL}/dwebCnQrCollapsed.png`;
const QR_IMAGE_SRC_EXPANDED = `${BASE_OSS_URL}/dwebcnqrexpanded_360.png`;

const STORAGE_KEY = "wechat_qr_banner_closed";

const WeChatQRBannerDesktop = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof localStorage !== "undefined") {
      return localStorage.getItem(STORAGE_KEY) !== "false";
    }
    return true;
  });
  const [expanded, setExpanded] = useState(false);

  const handleClose = () => {
    setVisible(false);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, "false");
    }
  };

  if (!visible) return null;

  return (
    <div
      className={formatClassNames(styles.wrapper, expanded && styles.expanded)}
      onMouseEnter={() => {
        setExpanded(true);
        posthogEventEmitter({ action: "MP_QR_DESKTOP_CLICKED" });
      }}
      onMouseLeave={() => setExpanded(false)}
    >
      <div className={styles.collapsedContent}>
        <LazyImage
          src={QR_IMAGE_SRC_COLLAPSED}
          alt="WeChat QR"
          className={styles.collapsedIcon}
          width={32}
          height={32}
        />
      </div>
      <div className={styles.expandedContent}>
        <div
          className={styles.closeBanner}
          onClick={() => handleClose()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleClose();
          }}
          aria-label="close"
        >
          <CrossIcon size={14} />
        </div>
        <div
          className={styles.qrWrapper}
          role="none"
          onClick={() => posthogEventEmitter({ action: "MP_QR_DESKTOP_CLICKED" })}
        >
          <LazyImage
            src={QR_IMAGE_SRC_EXPANDED}
            alt="WeChat Mini Program QR Code"
            className={styles.qrImage}
            width={170}
            height={170}
          />
        </div>
        <p className={styles.bannerText}>小程序返现¥200</p>
      </div>
    </div>
  );
};

export default wrapperHOC(WeChatQRBannerDesktop, {
  componentName: "WeChatQRBannerDesktop",
  showForChina: true,
  showForMiniProgram: false,
});
